// The vocabulary for the "What changed" column in the Analytics activity stream, keyed by the
// `event_type` activity/ sends.
export const ACTIVITY_LABELS = {
  created: "Transaction created",
  received: "Dispute was received",
  generated: "Evidence was generated",
  regenerated: "Evidence PDF was regenerated",
  // Who sent the evidence, and how. A submission a team member approved and one the rule
  // engine sent on schedule are different events to everyone reading the log.
  approved: "Approved and submitted by _name_",
  submitted_auto: "Evidence was submitted automatically",
  review: "Evidence is ready for your review",
  pending: "Awaiting the issuer decision",
  won: "Dispute was won",
  lost: "Dispute was lost",
  escalated: "Inquiry escalated towards a formal dispute",
  not_fought: "Dispute was not fought"
}
